//setActiveGateway();

const selectors = {
  gatewayLinks: '[data-gateway-selector]',
};

class GatewaySelector {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupEventListeners();
  }

  _getElements() {
    const gatewayLinks = document.querySelector(selectors.gatewayLinks);
    return gatewayLinks ? {
      gatewayLinks: document.querySelectorAll(selectors.gatewayLinks),
    } : {};
  }

  _setupEventListeners() {
    this.elements.gatewayLinks.forEach((element) => {
      element.addEventListener('click', this._handleSelectClick);
    });
  }

  _setGatewayCookie(value, newlocation) {
    fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          body: JSON.stringify({ attributes : { gateway_choice : value }}),
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': `application/json` }
        }
    )
    .then(function(response) {
      location.assign(newlocation);
    })
  }

  _handleSelectClick = (e) => {
    const value = e.currentTarget.dataset.gatewaySelector;
    e.preventDefault();
    this._setGatewayCookie(value, e.currentTarget.href);
  }
}
new GatewaySelector();